import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { contentStyles, gradientStyle, headingStyles } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  background: var(--bgColor);
  color: var(--fgColor);

  &[data-bg='white'] {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
    margin: var(--sectionSpacing) 0;

    ${SectionWrapperStyles.Inner} {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`;
const Title = styled.h2 `
  ${headingStyles};
  --titleColor: ${brand.secondary.red5};
  color: var(--titleColor);
  position: relative;

  &[data-title-theme='mid'] {
    --titleColor: ${brand.secondary.red3};
  }

  &[data-title-theme='light'] {
    --titleColor: ${brand.secondary.red1};
  }

  &[data-title-theme='gradient'] {
    ${gradientStyle};
  }

  &[data-title-size='small'] {
    font-size: ${fluidAdjusted(28, 48)};
    line-height: ${fluidAdjusted(36, 58)};
  }

  &[data-title-size='medium'] {
    font-size: ${fluidAdjusted(32, 64)};
    line-height: ${fluidAdjusted(40, 74)};
  }

  &[data-title-size='large'] {
    font-size: ${fluidAdjusted(64, 126)};
    line-height: ${fluidAdjusted(74, 136)};
  }
`;
const Content = styled.div `
  ${contentStyles};
  width: 100%;

  &[data-width='half'] {
    max-width: 720px;
  }

  &[data-image='true'] {
    @media ${from(Device.Tablet)} {
      min-height: 200px;
    }
  }

  a {
    display: inline;
  }

  img {
    border-radius: 16px;
    box-shadow: 10px 10px 0px 0px ${rgba(brand.buff.buff3, 1)};

    margin-bottom: 40px;
    width: 100%;

    @media ${from(Device.Tablet)} {
      float: right;
      max-width: 300px;
      width: auto;
      margin-left: 10px;
      margin-bottom: 20px;
    }
  }
`;
const RichTextStyles = {
    Container,
    Content,
    Title,
};
export default RichTextStyles;
